/**
 * Visually hidden honeypot field. Bots fill every input; humans never see this.
 * Submit handler should check the value and silently succeed when non-empty.
 */
interface Props {
  value: string;
  onChange: (v: string) => void;
  name?: string;
}
const Honeypot = ({ value, onChange, name = "website" }: Props) => (
  <div
    aria-hidden="true"
    style={{
      position: "absolute",
      left: "-10000px",
      top: "auto",
      width: 1,
      height: 1,
      overflow: "hidden",
    }}
  >
    <label htmlFor={`hp-${name}`}>Leave this field empty</label>
    <input
      id={`hp-${name}`}
      type="text"
      name={name}
      tabIndex={-1}
      autoComplete="off"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

export default Honeypot;
